import { Card, CardContent } from '@material-ui/core';
import React from 'react';
import { skeleton } from '../../style';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => skeleton(theme));

const FormSkeleton = () => {
    const classes = useStyles();
    return (
        <Card>
            <CardContent>
                <div className={classes.skelSection}>
                    <div className={`${classes.skel} ${classes.skelLabel}`} />
                    <div className={classes.skelFieldsRow}>
                        <div className={`${classes.skel} ${classes.skelField}`} />
                        <div className={`${classes.skel} ${classes.skelField}`} />
                    </div>
                </div>
                <div className={classes.skelSection}>
                    <div className={`${classes.skel} ${classes.skelLabel}`} />
                    <div className={classes.skelFieldsRow}>
                        <div className={`${classes.skel} ${classes.skelField}`} />
                        <div className={`${classes.skel} ${classes.skelField}`} />
                        <div className={`${classes.skel} ${classes.skelField}`} />
                    </div>
                </div>
                <div className={classes.skelSection}>
                    <div className={`${classes.skel} ${classes.skelLabel}`} />
                    <div className={classes.skelTilesGrid}>
                        <div className={`${classes.skel} ${classes.skelTile}`} />
                        <div className={`${classes.skel} ${classes.skelTile}`} />
                        <div className={`${classes.skel} ${classes.skelTile}`} />
                    </div>
                </div>
                <div className={classes.skelSection} style={{ marginBottom: 0 }}>
                    <div className={`${classes.skel} ${classes.skelLabel}`} />
                    <div className={`${classes.skel} ${classes.skelTextarea}`} />
                </div>
            </CardContent>
        </Card>
    );
};

export default FormSkeleton;
